import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PosSettingsPage } from './pos-settings.page';
import { AuthGuard } from 'src/app/services/user/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: PosSettingsPage
  },
  {
    path: 'taxes',
    loadChildren: () => import('./taxes/taxes.module').then( m => m.TaxesPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'currency',
    loadChildren: () => import('./currency/currency.module').then( m => m.CurrencyPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'payment-types',
    loadChildren: () => import('./payment-types/payment-types.module').then( m => m.PaymentTypesPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'discounts',
    loadChildren: () => import('./discounts/discounts.module').then( m => m.DiscountsPageModule),
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PosSettingsPageRoutingModule {}
